import { render, staticRenderFns } from "./candidates.vue?vue&type=template&id=56913e7a&"
import script from "./candidates.vue?vue&type=script&lang=js&"
export * from "./candidates.vue?vue&type=script&lang=js&"
import style0 from "./candidates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports